import React from 'react';

const Cta = props => (
  <div className="business-cta-1x">
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <div className="cta-content">
            <h3>{props.cta.ctaHeading}</h3>
            <h2>{props.cta.ctaTitle}</h2>
            <a href={props.cta.ctaLink} className="bussiness-btn-larg">
              {props.cta.ctaBody}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div className="padding-top-large" />
  </div>
);

export default Cta;



// WEBPACK FOOTER //
// ./src/components/Cta.js